<template>
    <v-container class="max-container">
        <v-row>
            <v-breadcrumbs class="no-pd-l" large :items="breadCrumbsItems"></v-breadcrumbs>
        </v-row>
        <v-row class="reward__row">
            <v-col xs="12" sm="12" md="5" lg="5" class="no-pd reward__col_txt">
                    <h1 class="reward__col_txt--font-responsive">{{ contextObject.title }}</h1>
                    <p>{{ contextObject.description }}</p>
            </v-col>
            <v-col xs="12" sm="12" md="7" lg="7" class="no-pd flex-col-center">
                <v-img :src="contextObject.image" class="reward" max-height="300px" width="100%" max-width="600px">
                    <div class="reward__col_image_header_title" :style="{'background-color': isOffer ? currentCompany.primaryColor : currentCompany.buttonsColor}">
                        <span v-if="!isOffer" class="text-white reward__col_image_font_size"> {{ contextObject.pointsToRedeem }} pontos </span>
                        <v-icon class="reward__col_image_icon_size" v-if="isOffer" color="var(--cor--branco)">mdi-gift</v-icon>
                    </div>
                </v-img>
            </v-col>
        </v-row>

        <div class="margin-top-divider-30" />

        <v-row class="flex-row-center">
            <h1 class="reward__icons_title">Instruções para resgatar</h1>

            <v-col xs="12" sm="12" md="12" lg="12" class="w-100" :class="!mobileVersion? 'flex-row-center':'flex-col-center'">
                <div class="flex-col-center reward__icons_div" :class="mobileVersion? 'btn__mg-b--mobile':'icon__mg--pc'">
                    <v-icon class="reward__icons--icons" color="var(--cor--preta)">mdi-book-open-variant</v-icon>
                    Verificar as condições 
                </div>
                <div class="flex-col-center reward__icons_div" :class="mobileVersion? 'btn__mg-b--mobile':'icon__mg--pc'">
                    <v-icon class="reward__icons--icons" color="var(--cor--preta)">mdi-notebook</v-icon>
                    Se apresentar na loja
                </div>
                <div class=" flex-col-center reward__icons_div" :class="mobileVersion? '':'icon__mg--pc'">
                    <v-icon color="var(--cor--preta)">mdi-gift</v-icon>
                    Fazer o resgate na loja
                </div>
            </v-col>
        </v-row>

        <div class="margin-top-divider-30" />

        <v-row class="flex-col-center no-pd">
            <v-col xs="12" sm="12" md="12" lg="12" class="w-100 no-pd-t" :class="!mobileVersion? 'flex-row-center':'flex-col-center'">
                <v-btn color="var(--cor--preta)" outlined class="custom-btn" :class="mobileVersion? 'btn__mg-b--mobile':''" @click="openRulesModal()">
                    <span class="text-none"> Consultar Regras </span>
                </v-btn>

                 <v-btn color="var(--cor--preta)" outlined class="custom-btn w-btn" :class="!mobileVersion? 'btn--left':''" @click="redirectToAddress()">
                    <span class="text-none"> Nossas Lojas </span>
                </v-btn>
            </v-col>
        </v-row>

        <div v-if="rulesDialog">
            <RulesModal :dialog="rulesDialog" @closeRulesModal="rulesDialog = $event" />
        </div>

    </v-container>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Services
import { getUserPrizeByCompanyIdAndCurrentContactIdAndId, getLoyaltyPrizeByCompanyIdAndCurrentContactIdAndId } from "./service/reward-detail-service";

//Components
import RulesModal from "@/app/modals/rules-modal/rules-modal";

export default {
    name: 'RewardDetail',
    components: { RulesModal },
    computed: {
        ...mapGetters('authenticateStore', {
            currentCompany: 'get_currentCompany'}
        )
    },
    data: () => ({
        isOffer:    false,
        contextObject:{
            title: 'Compre 1 milk shake e ganhe outro',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
            image: '',            
            pointsToRedeem: '80'
        },
        mobileVersion: null,
        breadCrumbsItems : [
        { text: 'Início', disabled: false, to: '/inicio' },
        { text: 'Oferta', disabled: true }
      ],
      rulesDialog: false
    }),
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
        this.getDetailsInfo()
    },
    methods: {
        ...mapActions('rewardLoaderStore', ['SET_REWARD_STATE']),
        compareWidth() {
            if( window.innerWidth <= 390 ) {
                this.mobileVersion = true              
            } else {
                this.mobileVersion = false                
            }
            if( window.innerWidth <= 960 ) {
                this.colBreak = true              
            } else {
                this.colBreak = false                
            }
            
        },
        getDetailsInfo(){
            var id = this.$route.params.id
            //se a primeira letra for 'o' é oferta, se for 'r' é recompensa
            this.isOffer = id.substring(0, 1) == 'o'
            if(this.isOffer){
                getUserPrizeByCompanyIdAndCurrentContactIdAndId(this.currentCompany.id, id.substring(1))
                    .then(success => {
                        this.populateContextObject(success.data)
                        this.breadCrumbsItems[1].text = 'Oferta'
                        this.SET_REWARD_STATE(true)
                    })
                    .catch( error => {
                        this.SET_REWARD_STATE(true)

                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    })
            } else {
                getLoyaltyPrizeByCompanyIdAndCurrentContactIdAndId(this.currentCompany.id, id.substring(1))
                    .then(success => {
                        this.populateContextObject(success.data)
                        this.breadCrumbsItems[1].text = 'Recompensa'
                        this.SET_REWARD_STATE(true)
                    })
                    .catch( error => {
                        this.SET_REWARD_STATE(true)

                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    })
            }
        },
        populateContextObject(data){
            this.contextObject.title = data.title
            this.contextObject.description = data.description
            this.contextObject.pointsToRedeem = data.pointsToRedeem
            if(data.image != null){
                this.contextObject.image = data.image
            } else {
                this.contextObject.image = 'https://lity-prod.s3-sa-east-1.amazonaws.com/images/LITY_GIFT.gif'
            }
        },
        openRulesModal(){
            this.rulesDialog = true
        },
        redirectToAddress(){
            this.$router.push( {path: '/loja'} )
        }

    }
}
</script>

<style scoped>
::v-deep .v-icon.v-icon {
        font-size: 50px !important;
    }
::v-deep .reward__col_image_header_title .v-icon{
    font-size: 150% !important;
}
.reward{
    border-radius: 14px;
}
.btn__mg-b--mobile{
    margin-bottom: 24px;
}
.w-btn {
    width: 159px;
}
.mg-t-h4 {
    margin-top: 8px;
}
.icon__mg--pc{
    margin: 14px;
}
.reward__col_txt{
    display: flex;
    flex: auto !important;
    flex-direction: column;   
    justify-content: start;
}
.reward__col_image_header_title{
    height: 14%;
    display:flex;
    justify-content: center;
    align-items: center;
}
.reward__col_image_icon_size{
    font-size: 30px !important;
}
.reward__col_image_font_size{
    font-size: 80% !important;
}
.reward__icons_title{
    color: var(--cor--roza);
    text-align: center !important;
}
.reward__icons_div {
    color: var(--cor--preta);
    text-align: center;
}

@media (max-width: 960px) {
    .reward__col_txt{
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-bottom: 30px;
    }
    ::v-deep .v-icon.v-icon {
        font-size: 40px !important;
    }
    ::v-deep .reward__col_image_header_title .v-icon{
    font-size: 150% !important;
}
}
@media (max-width: 600px) {
    .reward__row{
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .reward__col_txt--font-responsive{
        font-size: 24px;
    }
    .reward__icons_title{
        font-size: 24px;
    }
    ::v-deep .v-icon.v-icon {
        font-size: 30px !important;
    }
    ::v-deep .reward__col_image_header_title .v-icon{
    font-size: 100% !important;
}
}
</style>